import $foreign from "./foreign.cjs";
var _localeCompare = $foreign._localeCompare;
var joinWith = $foreign.joinWith;
var replace = $foreign.replace;
var replaceAll = $foreign.replaceAll;
var split = $foreign.split;
var toLower = $foreign.toLower;
var toUpper = $foreign.toUpper;
var trim = $foreign.trim;
export { _localeCompare, joinWith, replace, replaceAll, split, toLower, toUpper, trim };
